module.exports = __webpack_public_path__ + "c979ebe9e0ffeaf24328571a62d02555.png";